import { hotRadar } from "@/mocks/editorial";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-ink-950 pt-28 pb-16 text-paper-50 md:pt-36 md:pb-24">
      {/* 背景纹理层 */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.15]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 15% 20%, #c7452b 0, transparent 30%), radial-gradient(circle at 85% 75%, #a9862f 0, transparent 30%), repeating-linear-gradient(45deg, rgba(255,255,255,0.06) 0 1px, transparent 1px 12px)",
        }}
      />
      <div className="pointer-events-none absolute right-0 top-0 h-64 w-64 rounded-full bg-ember-700/30 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/4 h-64 w-64 rounded-full bg-amberstone-600/20 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-ember-500/50 bg-ember-600/15 px-4 py-1.5 text-xs tracking-wide text-ember-100">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ember-500 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-ember-500" />
              </span>
              持续追踪 · 每期更新
            </div>
            <h1 className="font-display text-3xl font-black leading-tight md:text-5xl md:leading-tight">
              看透镜头之外的
              <span className="mt-1 block text-ember-400">操控与博弈</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-paper-100/75 md:text-lg">
              从台本工业到剪辑叙事，从选手人设到导师争议——大瓜观察局以行业常识与传播学视角，把综艺里被热议的「瓜」拆开讲清楚，带你理性看待节目镜头背后的真实运作。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#columns"
                className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-ember-600 px-7 py-3.5 text-sm font-semibold text-paper-50 transition hover:bg-ember-500"
              >
                开始吃瓜
                <i className="ri-arrow-right-line ml-2" />
              </a>
              <a
                href="#deep"
                className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-paper-50/25 px-7 py-3.5 text-sm text-paper-50 transition hover:border-ember-500 hover:text-ember-200"
              >
                <i className="ri-book-open-line mr-2" />
                阅读深读
              </a>
            </div>
          </div>

          {/* 热点雷达 */}
          <div className="relative">
            <div className="mb-3 flex items-center justify-between px-1">
              <span className="font-display text-sm font-bold tracking-wide">热点雷达 HOT RADAR</span>
              <span className="flex items-center gap-1 text-xs text-ember-300">
                <i className="ri-fire-line" /> 实时讨论中
              </span>
            </div>
            <div className="flex flex-col gap-3">
              {hotRadar.slice(0, 4).map((h, i) => (
                <a
                  key={i}
                  href="#deep"
                  className="group rounded-xl border border-paper-50/10 bg-paper-50/[0.04] p-4 transition hover:border-ember-500/40 hover:bg-paper-50/[0.08]"
                >
                  <div className="flex items-start gap-3">
                    <span className="font-display text-xl font-black text-ember-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <span className="rounded bg-ink-700 px-2 py-0.5 text-[11px] text-paper-200/80">
                          {h.tag}
                        </span>
                        <span className="ml-auto flex items-center gap-1 whitespace-nowrap text-xs text-ember-300">
                          <i className="ri-flashlight-fill text-ember-500" />
                          {h.heat}°
                        </span>
                      </div>
                      <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-paper-100/85 transition group-hover:text-paper-50">
                        {h.title}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
            <a
              href="#radar"
              className="mt-3 flex items-center justify-center gap-2 rounded-xl border border-dashed border-paper-50/20 py-3 text-xs text-paper-200/70 transition hover:border-ember-500/50 hover:text-ember-200"
            >
              <i className="ri-search-line" /> 检索更多议题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}